const VERSION = '2.0.23a'
export default VERSION
